/* eslint-disable
    no-restricted-syntax
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {addBreadcrumb} from '@sentry/browser';
import reactUpdate from 'immutability-helper';
import $ from 'jquery';
import isEqual from 'react-fast-compare';
import _ from 'underscore';
import {v4 as uuidv4} from 'uuid';

import Digests from 'analyses/Digests';
import {ArchiveRecord} from 'archive/ArchiveConstants';
import {StandardFeature} from 'auth/capabilities/CapabilityConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import {Permissions} from 'auth/PermissionConstants';
import * as benchlingUtil from 'BenchlingUtil';
import MoleculeFileState from 'chemistry/molecules/tabs/MoleculeFileState';
import {EventConstants} from 'constants/EventConstants';
import {WorkspaceItem, WorkspaceItemInput, WorkspaceServerItem} from 'constants/FileBrowserConstants';
import {NumberIDFolder, StringIDFolder} from 'constants/FolderConstants';
import ModelTypeConstants, {FOLDER_ITEM_TYPES} from 'constants/ModelTypeConstants';
import {TagSchema} from 'constants/RegistryConstants';
import {User} from 'constants/UserConstants';
import FileState from 'filestate/FileState';
import FolderItemState from 'filestate/FolderItemState';
import FileStates, {
  BasicFolderItemFileState,
  EntryFileState,
  MixtureFileState,
  ProteinFileState,
  ProtocolFileState,
  SequenceFileState,
} from 'FileStates';
import {Tag} from 'folder-items/FileConstants';
import AppDispatcher, {FluxAction} from 'lib/Dispatcher';
import navigateToURL from 'lib/navigateToURL';
import Store from 'lib/Store';
import AutoSaver from 'notebook/store/auto-save/AutoSaver';
import notifications from 'notifications';
import ProcessFileState from 'processes/process-details/ProcessFileState';
import {SchemaValidationState} from 'schemas/SchemaValidationConstants';
import EntityStore from 'stores/EntityStore';
import * as TagSchemaUtil from 'tag-schema/util/TagSchemaUtil';
import APIUtil from 'util/APIUtil';

import WorkspaceDAO from './WorkspaceDAO';

let HAS_BOOTSTRAPPED_WORKSPACE = false;

/* This should stay in sync with @minWidth--workspace-itemTab in Workspace.less. */
export const MIN_TAB_WIDTH = 150;

interface SequenceWorkspaceItem extends WorkspaceItem {
  type?:
    | SequenceFileState
    | EntryFileState
    | ProtocolFileState
    | BasicFolderItemFileState
    | ProteinFileState
    | MixtureFileState
    | ProcessFileState
    | MoleculeFileState;
}

export type WorkspaceItemVariant = WorkspaceItem | SequenceWorkspaceItem;

export interface WorkspaceState {
  workspaceItems: Array<WorkspaceItemVariant>;
  activeId: string | null;
  activeFileType: ModelTypeConstants | null;
}

class WorkspaceStore extends Store {
  static SKIPPED_FILE_TYPES: Array<string> = [];

  autoSaver: AutoSaver | null = null;
  workspaceItems: Array<WorkspaceItemVariant> = [];
  workspaceLastServerItems: Array<WorkspaceServerItem> = [];
  fileStates!: FileStates;
  workspaceWidth?: number | null;
  activeId: string | null = null;
  activeFileType: ModelTypeConstants | null = null;
  workspaceOpenVersion: number = 0;
  workspaceSavedVersion: number = 0;

  listenToFileStates(fileStates: FileStates): void {
    // TODO(T1306): Also update when modifiedAt changes.
    this.fileStates = fileStates;
    this.listenTo(this.fileStates, 'add remove reset change:active', () => {
      this._fileStatesActiveSync(true);
    });

    this.listenTo(this.fileStates, 'change:id', (fileState: FileState): void => {
      this._onIdChange(fileState);
      this._fileStatesActiveSync(true);
    });

    this.listenTo(
      this.fileStates,
      'add change:name change:tagSchema change:archiveRecord',
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this._syncWorkspaceItems
    );
    this._fileStatesActiveSync(false);
  }

  _onIdChange(fileState: FileState): void {
    this.workspaceItems = this.workspaceItems.map((item) =>
      item.fileId === fileState.previous('id')
        ? {
            ...item,
            fileId: fileState.id,
            // The backend has an implicit invariant that `fileId` never changes for a given WorkspaceItem,
            // which is relied on when syncing workspace items. If we violate this invariant, the backend may
            // persist multiple workspace items linking to the same file, which violates a uniqueness
            // constraint. To avoid this and uphold the invariant, we simply regenerate the id, i.e. delete
            // and replace the existing WorkspaceItem with a new one.
            id: uuidv4(),
          }
        : item
    );
    this.emitChange();
    this._bumpWorkspaceVersion();
  }

  _syncWorkspaceItems(fileState: FileState): void {
    this.workspaceItems = (() => {
      const result: Array<WorkspaceItemVariant> = [];
      for (const workspaceItem of this.workspaceItems) {
        if (workspaceItem.fileId === fileState.id) {
          const properties = {
            id: workspaceItem.id,
            fileId: workspaceItem.fileId,
            name: fileState.name() ?? workspaceItem.name,
            archiveRecord: fileState.archiveRecord(),
            schemaValidationState: fileState.schemaValidationState() ?? workspaceItem.schemaValidationState,
            tagSchema: fileState.get('tagSchema'),
            ...(fileState.get('sequence') != null && {type: fileState.get('sequence').type()}),
            ...(fileState.get('procedure') != null && {
              procedureType: fileState.get('procedure').procedureType,
            }),
          };
          result.push(reactUpdate(workspaceItem, {$merge: properties}));
        } else {
          result.push(workspaceItem);
        }
      }
      return result;
    })();
    this.emitChange();
  }

  /**
   * Directly modify the state of a workspace item.
   *
   * This is useful when you want to modify the state of an unopened entity (e.g., change its workspace tab),
   * as unopened entities have no filestate and thus any filestate changes will not sync with the workspace.
   */
  _setWorkspaceItemState(fileId: string, state: Partial<WorkspaceItemVariant>): void {
    const index = this.workspaceItems.findIndex((workspaceItem) => workspaceItem.fileId === fileId);
    if (index < 0) {
      return;
    }
    this.workspaceItems = reactUpdate(this.workspaceItems, {
      [index]: {
        $merge: state,
      },
    });
    this.emitChange();
  }

  /**
   * This is called when workspace tabs are added, removed, and opened
   */
  _fileStatesActiveSync(shouldEmitChange?: boolean): void {
    if (shouldEmitChange == null) {
      shouldEmitChange = true;
    }
    const activeFile: FileState = this.fileStates.find(
      (fileState) => fileState.get('active') && this.fileStates.isWorkspaceItem(fileState)
    );
    this.activeId = activeFile != null ? activeFile.id : null;
    if (activeFile != null) {
      // TODO(T2966) stop checking specially for oligos
      if (
        activeFile.fileType() === ModelTypeConstants.SEQUENCE &&
        (activeFile as SequenceFileState).model().type() === 'oligo'
      ) {
        this.activeFileType = ModelTypeConstants.DNA_OLIGO;
      } else {
        this.activeFileType = activeFile.fileType();
      }
      this._revealTabIfHidden(activeFile);
    } else {
      this.activeFileType = null;
    }
    if (shouldEmitChange) {
      this.emitChange();
    }
  }

  _workspaceServerItems(): Array<WorkspaceServerItem> {
    return this.workspaceItems
      .filter(
        (workspaceItem) =>
          !WorkspaceStore.SKIPPED_FILE_TYPES.includes(APIUtil.apiIdToType(workspaceItem.fileId))
      )
      .map((workspaceItem) => ({id: workspaceItem.id, fileId: workspaceItem.fileId}));
  }

  _bumpWorkspaceVersion(): void {
    if (HAS_BOOTSTRAPPED_WORKSPACE) {
      this.workspaceOpenVersion += 1;
    }
  }

  _addToWorkspace(
    fileId: string,
    item: WorkspaceItemInput,
    {workspaceItemId = null, index = 0}: {workspaceItemId?: string | null; index?: number} = {}
  ): void {
    if (!isFeatureEnabled({feature: StandardFeature.OPEN, item: {id: fileId}})) {
      return;
    }

    if (this._findInWorkspace(fileId)) {
      return;
    }

    const workspaceItem: WorkspaceItem = {
      id: workspaceItemId != null ? workspaceItemId : uuidv4(),
      fileId,
      name: item.name,
      tagSchema: item.tagSchema ?? null,
      archiveRecord: item.archiveRecord ?? null,
      schemaValidationState: item.schemaValidationState ?? null,
      procedureType: item.procedureType ?? null,
    };

    this.workspaceItems = reactUpdate(this.workspaceItems, {$splice: [[index, 0, workspaceItem]]});
    this._bumpWorkspaceVersion();
  }

  /**
   * Return the next file ID to open, or null if none could be found.
   *
   * Returns the first non-closed item to the left, or the first non-closed item to the right if there are
   * no open items to the left.
   */
  _getNextFileIdToOpen(newWorkspaceItems: Array<WorkspaceItemVariant>): string | null {
    if (!this.activeId) {
      return null;
    }
    const activeItemIndex = this._findIndexInWorkspace(this.activeId);
    if (activeItemIndex === -1) {
      return null;
    }

    const isStillInWorkspace = (workspaceItem: WorkspaceItem): boolean =>
      _.pluck(newWorkspaceItems, 'fileId').includes(workspaceItem.fileId);
    const openItemsOnLeft = this.workspaceItems
      .slice(0, activeItemIndex)
      .filter((wsItem) => isStillInWorkspace(wsItem));
    if (openItemsOnLeft.length > 0) {
      return _.last(openItemsOnLeft)!.fileId;
    }
    const openItemsOnRight = this.workspaceItems
      .slice(activeItemIndex + 1)
      .filter((wsItem) => isStillInWorkspace(wsItem));
    if (openItemsOnRight.length > 0) {
      return openItemsOnRight[0].fileId;
    }
    return null;
  }

  _shouldCloseFileWithUnsavedChanges(fileId: string): boolean {
    const fileState = this.fileStates.get(fileId);
    if (fileState && fileState.hasUnsavedChanges()) {
      addBreadcrumb({
        category: 'bnch.nav',
        message: 'Prompted to close unsaved files',
        level: 'info',
      });
      // oxlint-disable-next-line no-alert
      return !window.confirm(
        `"${fileState.name()}" has unsaved changes. Do you want to close the tab and discard ` +
          'your changes?'
      );
    }
    return false;
  }

  _closeAllFilesExcept(keepFilter: (fileId: string) => boolean): void {
    // Determine the workspace items / filestates that need to be killed.
    const [newWorkspaceItems, removedWorkspaceItems] = _.partition(
      this.workspaceItems,
      ({fileId}) => keepFilter(fileId) || this._shouldCloseFileWithUnsavedChanges(fileId)
    );
    const condemnedFileStates = _.compact(
      removedWorkspaceItems.map((workspaceItem) => this.fileStates.get(workspaceItem.fileId))
    );
    const nextFileIdToOpen = this._getNextFileIdToOpen(newWorkspaceItems);

    // Before we start cleaning up our stores, we need to unrender any views that might be listening to
    // those stores. We trigger an event so filebarview can handle unrendering now.
    const hadActive = this.activeId != null;
    if (hadActive && _.pluck(removedWorkspaceItems, 'fileId').includes(this.activeId)) {
      this.fileStates.trigger('unmount');
      this.activeId = null;
    }

    // Now that no relevant view is listening to the stores, remove files from stores
    this.fileStates.closeAll(condemnedFileStates);

    // Clean up sequences
    const fileIds = condemnedFileStates.map((fileState) => fileState.id);
    condemnedFileStates.forEach((fileState) => {
      if (fileState.fileType() === ModelTypeConstants.SEQUENCE) {
        const digests = Digests.get();
        digests.remove(digests.filter((digest) => _.contains(fileIds, digest.get('sequence').id)));
      }
    });

    // Update workspace store state
    this.workspaceItems = newWorkspaceItems;
    this._bumpWorkspaceVersion();

    // If we don't have anything open, try to open something.
    if (hadActive && this.activeId == null) {
      if (nextFileIdToOpen != null) {
        const FileBrowserActions = require('file-browser/FileBrowserActions').default;
        FileBrowserActions.openFile(nextFileIdToOpen);
      } else {
        navigateToURL('/editor');
      }
    }
  }

  /**
   * @param {String} workspaceItemId  API id of the workspace item to move
   * @param {Number} toIndex          index to move to
   */
  _moveWorkspaceTab(workspaceItemId: string, toIndex: number): void {
    const fromIndex = _.findIndex(this.workspaceItems, (item) => item.fileId === workspaceItemId);
    if (fromIndex < 0) {
      return;
    }
    const item = this.workspaceItems[fromIndex];
    this.workspaceItems = reactUpdate(this.workspaceItems, {
      $splice: [
        [fromIndex, 1],
        [toIndex, 0, item],
      ],
    });
    this._bumpWorkspaceVersion();
  }

  _removeFromWorkspace(fileId: string): void {
    this._closeAllFilesExcept((workspaceItemFileId: string) => workspaceItemFileId !== fileId);
  }

  _clearWorkspace(itemIdsToKeep: Array<string> = []): void {
    this._closeAllFilesExcept((itemFileId: string) => itemIdsToKeep.includes(itemFileId));
  }

  _findInWorkspace(fileId: string): WorkspaceItemVariant | undefined {
    return _.findWhere(this.workspaceItems, {fileId});
  }

  _findIndexInWorkspace(fileId: string): number {
    return _.findIndex(this.workspaceItems, {fileId});
  }

  _syncTagSchema(tagSchema: TagSchema): void {
    this.workspaceItems = this.workspaceItems.map((workspaceItem) =>
      (workspaceItem.tagSchema != null ? workspaceItem.tagSchema.id : undefined) === tagSchema.id
        ? reactUpdate(workspaceItem, {tagSchema: {$set: tagSchema}})
        : workspaceItem
    );
  }

  _syncTags(tagData: Array<{id: string; tags: Array<Tag>}>): void {
    const indexedTagData = _.indexBy(tagData, 'id');
    this.workspaceItems.forEach((workspaceItem) => {
      const {fileId} = workspaceItem;
      // File state may not be open yet if the user's started a new session
      const fileState = this.fileStates.get(fileId);
      if (fileState == null) {
        return;
      }
      // File may not support tags / schemas (e.g. templates)
      if (!(TagSchemaUtil.hasFileSchemaSupport(fileId) || FOLDER_ITEM_TYPES.includes(fileState.fileType()))) {
        return;
      }
      // File may not have been affected
      const fileTagData = indexedTagData[fileId];
      if (fileTagData == null) {
        return;
      }
      // This can call another action (entry update actions) until we move to using a single action.
      // TODO(T4630): Unify these actions
      _.defer(() => {
        (fileState as FolderItemState).model().setTags(fileTagData.tags);
      });
    });
  }

  _syncAuthors(fileId: string, authors: Array<User>): void {
    const fileState = this.fileStates.get(fileId);
    if (fileState == null) {
      return;
    }
    _.defer(() => {
      (fileState as FolderItemState).model().setAuthors(authors);
    });
  }

  _syncPermissions(fileId: string, permissions: Permissions): void {
    const fileState = this.fileStates.get(fileId);
    if (fileState == null) {
      return;
    }
    _.defer(() => {
      fileState.setPermissions(permissions);
    });
  }

  _syncFolder(fileId: string, folder: StringIDFolder | NumberIDFolder): void {
    const model = this.fileStates.get(fileId)?.folderItemModelToSync();
    if (model == null) {
      return;
    }
    _.defer(() => {
      model.setFolder(folder);
    });
  }

  _syncArchiveRecord(fileId: string, archiveRecord: ArchiveRecord | null): void {
    this._setWorkspaceItemState(fileId, {archiveRecord});

    const fileState = this.fileStates.get(fileId);
    if (fileState == null) {
      return;
    }
    _.defer(() => {
      fileState.setArchiveRecord(archiveRecord);
      this._syncWorkspaceItems(fileState);
    });
  }

  _syncValidationState(fileId: string, schemaValidationState: SchemaValidationState | null): void {
    this._setWorkspaceItemState(fileId, {schemaValidationState});

    const fileState = this.fileStates.get(fileId);
    if (!fileState) {
      return;
    }
    _.defer(() => {
      (fileState as FolderItemState).model().setSchemaValidationState(schemaValidationState);
      this._syncWorkspaceItems(fileState);
    });
  }

  saveWorkspace(): JQueryPromise<boolean> {
    // Create a deferred promise that will be resolved once the save has completed.
    const deferredPromise = $.Deferred<boolean>();
    benchlingUtil.asyncThrottle('workspace', () => {
      // Prevent multiple workspace saves at the same time
      // No need to save if the workspace is up-to-date.
      let id;
      if (this.workspaceOpenVersion === this.workspaceSavedVersion) {
        return deferredPromise.resolve(false).promise();
      }

      const currentVersion = this.workspaceOpenVersion;
      const workspaceServerItems = this._workspaceServerItems();
      const lastItemsMap = _.indexBy(this.workspaceLastServerItems, 'id');
      const itemsMap = _.indexBy(workspaceServerItems, 'id');
      const changedItems = workspaceServerItems.filter((item) => !isEqual(lastItemsMap[item.id], item));
      const deletedIds = (() => {
        const result = [];
        for (id in lastItemsMap) {
          if (!(id in itemsMap)) {
            result.push(id);
          }
        }
        return result;
      })();

      const payload = {
        itemsPresent: changedItems,
        deletedIds,
        tabOrder: _.pluck(workspaceServerItems, 'id'),
      };

      return WorkspaceDAO.update(payload)
        .done((response) => {
          this.workspaceSavedVersion = currentVersion;
          this.workspaceLastServerItems = workspaceServerItems;
          // Resolve the deferred promise to signal that the save has completed.
          deferredPromise.resolve(true);
        })
        .fail((response) => {
          // If it's not a client/server error (4xx or 5xx), then retry auto-saving silently
          // Otherwise, pause auto-saving and show notification. We want to retry on errors
          // that are > 500, since our servers should only be returning 500s.
          notifications.stickyNotifyForFriendlyError(response, 'workspace-save-fail');
          if (!(400 <= response.status && response.status <= 500)) {
            return;
          }
          this.autoSaver?.pause(
            {
              payload,
              workspaceSavedVersion: this.workspaceSavedVersion,
              currentVersion,
              status: response.status,
              error: response.responseJSON,
            },
            {skipClientDump: true}
          );
          // Resolve the deferred promise to signal that the save has failed.
          deferredPromise.resolve(false);
        });
    });
    // Return the deferred promise so that the caller can wait for the save to complete.
    return deferredPromise.promise();
  }

  loadFromServerBootstrap(): void {
    if (HAS_BOOTSTRAPPED_WORKSPACE) {
      return;
    }

    // On page load, we bootstrap in the user's workspace in window.bootstrap.workspaceItems
    // This method loops over the bootstrapped workspace items and adds them to the workspace
    const workspaceItemsJSON =
      window.bootstrap && window.bootstrap.workspaceItems
        ? window.bootstrap.workspaceItems.slice().reverse()
        : [];
    for (const itemJSON of workspaceItemsJSON) {
      // oxlint-disable-next-line @typescript-eslint/no-explicit-any
      if (!(itemJSON as {finder?: any}).finder) {
        this._addToWorkspace(
          itemJSON.fileId,
          {
            name: itemJSON.name,
            tagSchema: itemJSON.tagSchema,
            archiveRecord: itemJSON.archiveRecord,
            schemaValidationState: itemJSON.schemaValidationState,
            procedureType: itemJSON.procedureType,
          },
          {workspaceItemId: itemJSON.id}
        );
      }
    }

    // Since we just loaded everything from the server, set the current workspace to
    // workspaceLastServerItems. Otherwise, saveWorkspace would see that no workspaceLastServerItems
    // exist (and there for assume all workspace items are new), and would immediately do a sync with
    // all the workspace items we just loaded from the server
    this.workspaceLastServerItems = this._workspaceServerItems();
    HAS_BOOTSTRAPPED_WORKSPACE = true;
    this.emitChange();
  }

  override resetState(): void {
    HAS_BOOTSTRAPPED_WORKSPACE = false;
    this.workspaceItems = [];
    this.activeId = null;
    this.workspaceWidth = null;

    // Workspace persistence
    if (EntityStore.currentUser()) {
      if (this.autoSaver != null) {
        this.autoSaver.stop();
      }
      this.autoSaver = new AutoSaver({
        id: 'workspace-autosaver',
        friendlyName: 'workspace',
        doSave: this.saveWorkspace.bind(this),
        getItemState: () => ({
          openVersion: this.workspaceOpenVersion,
          savedVersion: this.workspaceSavedVersion,
        }),
        persistToLocalStorage: false,
        checkItemLoaded: false,
        showErrors: false,
      });
    }

    this.workspaceSavedVersion = 0;
    this.workspaceOpenVersion = 0;
  }

  getState(): WorkspaceState {
    return {
      workspaceItems: this.workspaceItems,
      activeId: this.activeId,
      activeFileType: this.activeFileType,
    };
  }

  /**
   * If tab associated with activeFile is hidden (i.e., in the overflow), shift to leftmost position
   */
  _revealTabIfHidden(activeFile: FileState): void {
    if (!this.activeId) {
      return;
    }
    const activeItemIndex = this._findIndexInWorkspace(this.activeId);
    if (activeItemIndex >= this.getMaxOverheadTabs()) {
      this._moveWorkspaceTab(activeFile.id, 0);
    }
  }

  /**
   * Return the max number of workspace tabs that can be displayed, given the workspace width
   *
   * Width is initially null when the workspace mounts, but is measured and updated. While width is null,
   * return a placeholder of infinite overhead tabs, to set an initial state of no hidden tabs (which require
   * more logic to manage).
   */
  getMaxOverheadTabs(): number {
    return this.workspaceWidth != null ? Math.floor(this.workspaceWidth / MIN_TAB_WIDTH) : Infinity;
  }

  override payloadHandler(action: FluxAction): boolean {
    switch (action.actionType) {
      case EventConstants.FILE_BROWSER_SOURCE_DELETED: {
        const {id} = action;
        this._removeFromWorkspace(id);
        this.emitChange();
        break;
      }

      case EventConstants.FILE_BROWSER_ITEMS_DELETED: {
        const {ids} = action;
        ids.forEach((fileId: string) => {
          this._removeFromWorkspace(fileId);
        });
        this.emitChange();
        break;
      }

      case EventConstants.FILE_BROWSER_ADD_TO_WORKSPACE: {
        let indexToInsertAt = 0;
        if (this.activeId) {
          const activeItemIndex = this._findIndexInWorkspace(this.activeId);
          indexToInsertAt = activeItemIndex + 1; // insert after current tab
        }
        this._addToWorkspace(action.fileId, action.item, {index: indexToInsertAt});
        this.emitChange();
        break;
      }

      case EventConstants.FILE_BROWSER_REMOVE_FROM_WORKSPACE:
        this._removeFromWorkspace(action.fileId);
        this.emitChange();
        break;

      case EventConstants.FILE_BROWSER_BULK_REMOVE_FROM_WORKSPACE:
        // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
        action.fileIds.forEach((fileId: string) => this._removeFromWorkspace(fileId));
        this.emitChange();
        break;

      case EventConstants.FILE_BROWSER_MOVE_WORKSPACE_TAB: {
        const {workspaceItemId, toIndex} = action;
        this._moveWorkspaceTab(workspaceItemId, toIndex);
        this.emitChange();
        break;
      }

      case EventConstants.FILE_BROWSER_CLEAR_WORKSPACE: {
        const {itemIdsToKeep} = action;
        this._clearWorkspace(itemIdsToKeep);
        this.emitChange();
        break;
      }

      case EventConstants.FILE_TAGS_UPDATED: {
        const {tagData} = action;
        this._syncTags(tagData);
        break;
      }

      case EventConstants.FILE_AUTHORS_UPDATED:
        this._syncAuthors(action.fileId, action.authors);
        this._syncPermissions(action.fileId, action.newPermissions);
        break;

      case EventConstants.BULK_ARCHIVE_FILES_COMPLETED:
      case EventConstants.BULK_ARCHIVE_SOURCES_COMPLETED: {
        const {itemIds, permissionsByItemId, archiveRecordsByItemId} = action;
        for (const itemId of Object.values<string>(itemIds)) {
          this._syncArchiveRecord(itemId, archiveRecordsByItemId[itemId]);
          this._syncPermissions(itemId, permissionsByItemId[itemId]);
        }
        break;
      }

      case EventConstants.BULK_UNARCHIVE_FILES_COMPLETED:
      case EventConstants.BULK_UNARCHIVE_SOURCES_COMPLETED: {
        const {itemIds, permissionsByItemId} = action;
        for (const itemId of Object.values<string>(itemIds)) {
          this._syncArchiveRecord(itemId, null);
          this._syncPermissions(itemId, permissionsByItemId[itemId]);
        }
        break;
      }

      case EventConstants.SIDEBAR_OPEN:
        this.emitChange();
        break;

      case EventConstants.TAG_SCHEMA_UPDATED: {
        const {tagSchema} = action;
        this._syncTagSchema(tagSchema);
        this.emitChange();
        break;
      }

      case EventConstants.WORKSPACE_WIDTH_UPDATED: {
        const {workspaceWidth} = action;
        this.workspaceWidth = workspaceWidth;
        this.emitChange();
        break;
      }

      case EventConstants.BIOENTITIES_VALIDATION_STATUS_UPDATED: {
        const {schemaValidationStateByBioentityId} = action;
        for (const itemId of Object.keys(schemaValidationStateByBioentityId)) {
          this._syncValidationState(itemId, schemaValidationStateByBioentityId[itemId]);
        }
        this.emitChange();
        break;
      }

      case EventConstants.FILE_BROWSER_UNREGISTER_FILES: {
        for (const id of action.ids) {
          this._syncValidationState(id, null);
        }
        this.emitChange();
        break;
      }

      case EventConstants.FILE_BROWSER_MOVE_FILES_COMPLETED: {
        const {ids, permissionsById, folder} = action;
        for (const itemId of ids) {
          if (permissionsById) {
            this._syncPermissions(itemId, permissionsById[itemId]);
          }
          this._syncFolder(itemId, folder!);
        }
        this.emitChange();
        break;
      }

      case EventConstants.BULK_ARCHIVE_PROCESS_MANAGEMENT: {
        const {itemIds, archiveRecordsByItemId} = action;
        for (const itemId of itemIds) {
          this._syncArchiveRecord(itemId, archiveRecordsByItemId[itemId]);
        }
        break;
      }

      case EventConstants.BULK_UNARCHIVE_PROCESS_MANAGEMENT: {
        const {itemIds} = action;
        for (const itemId of itemIds) {
          this._syncArchiveRecord(itemId, null);
        }
        break;
      }

      default:
        break;
    }

    return true;
  }
}

WorkspaceStore.initClass();

export default new WorkspaceStore(AppDispatcher);
